import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IInfoForPayModal } from 'src/app/interfaces/payment.interfaces';

@Component({
    selector: 'pat-info-for-pay-modal',
    templateUrl: './for-pay.component.html',
    styleUrls: ['./for-pay.component.scss'],
    standalone: false,
})
export class PatInfoForPayModalComponent {
    public email: string;
    public phone: string;
    public sum: number;
    public emailRequiredForPay: boolean;
    public phoneRequiredForPay: boolean;

    public constructor(
        public DialogRef: MatDialogRef<PatInfoForPayModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IInfoForPayModal,
    ) {
        this.email = data.initialEmail;
        this.phone = data.initialPhone;
        this.sum = data.sum;
        this.emailRequiredForPay = data.emailRequiredForPay;
        this.phoneRequiredForPay = data.phoneRequiredForPay;
    }
    public getPayErrorMessage(): string {
        const emailFilled = this.email && this.email.includes('@');
        const phoneFilled =
            this.phone && this.phone.replace(/\D/g, '').length >= 11;

        if (this.emailRequiredForPay && !emailFilled) {
            return 'Введите корректный email для оплаты.';
        }
        if (this.phoneRequiredForPay && !phoneFilled) {
            return 'Введите корректный номер телефона для оплаты.';
        }

        return '';
    }

    public validPay(): boolean {
        return !!this.getPayErrorMessage();
    }

    public submitPayment() {
        if (this.validPay()) return;

        this.DialogRef.close({
            email: this.email,
            phone: this.phone,
        });
    }
}
